let url = 'http://api.ebok.hispeed.pl'
// let url = 'http://ebok.l'

export const API_URL = url;


// WEBPACK FOOTER //
// ./src/config.js